export const SELECT_CARDS_MODES = "SELECT_CARDS_MODES";
export const INIT_CARDS_MODES = "INIT_CARDS_MODES";
export const CLEAN_CARDS_MODES = "CLEAN_CARDS_MODES";
